import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from '../../business-services/appointment.service';
import { OnHoldReasonList } from '../../business-entities/onHold-reason-list-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';


@Component({
  selector: 'app-onhold-status-change',
  templateUrl: './onhold-status-change.component.html'
})
export class OnholdStatusChangeComponent implements OnInit {

  @Input() currentWorkorderStatusId: number;
  @Input() appointmentId: number;
  @Input() workOrderNumber: string;
  @Input() isLockedByOtherUser: boolean=false;
  OnHoldConfirmation: boolean = false;
  onHoldStatusReasonList: OnHoldReasonList[];
  selectedReasonId: number;
  isCarRemainInWorkshop: boolean = true;
  isDisplayCarInWorkshop:boolean=false;
  features: Features[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private appointmentService: AppointmentService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
  ) { }

  ngOnInit(): void {
    this.features = this.secureStorage.getKeyData('feature');


    this.isCarRemainInWorkshop = false;
    this.isDisplayCarInWorkshop = (this.currentWorkorderStatusId === Enums.WOStatus.Waitingforcustomer) ? false : true;
  }

  confirmation(status: any) {
    this.OnHoldConfirmation = status;
    let langCode=this.cookieservice.get('userSelectedLanguage')
    if (status) {
      this.appointmentService.GetOnHoldStatusReasonList(langCode,Enums.ReasonType.OnHold).then(data => {
        let response = data.responseObject
        if (response?.errorCount === 1) {
          this.onHoldStatusReasonList = [];
        }
        else {
          this.onHoldStatusReasonList = this.onHoldStatusReasonListDataMapper(data.responseObject);
        }
      }
      )
    }
    else {
      this.onCrossClickModel();
    }
  }

  onCrossClickModel() {
    this.activeModal.close({
      success: true,
      isKeepOnHold: false
    });
    
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  submiteOnHoldDetails() {
    this.spinner.show();
    let errorMsg = this.translate.instant("lblDescriptionRequire");
    let selectedReason=this.onHoldStatusReasonList.filter(x=>x.reasonId===this.selectedReasonId)[0];
    if (selectedReason.isDescriptionRequire && !selectedReason.description) {
      this.toaster.error(errorMsg);
      this.spinner.hide();
    }
    else
    {
      let langCode=this.cookieservice.get('userSelectedLanguage')
      let viewModel=
      {
        workOrderNumber: this.workOrderNumber,
        appointmentId: this.appointmentId,
        fromWorkOrderStatusId: this.currentWorkorderStatusId,
        onHoldReasonId: this.selectedReasonId,
        description: selectedReason.isDescriptionRequire ? selectedReason.description :null,
        isCarRemainInWorkshop: this.isCarRemainInWorkshop,
        languageCode:langCode,
        integrationWithDMS:this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive,
        realtimeDmsSyncAppointment:this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive,
        moduleId:Enums.ModuleNames.Appointment
      }
      this.updateOnHoldStatus(viewModel);
            
    }
  }

  updateOnHoldStatus(viewModel) {
    this.appointmentService.UpdateOnHoldStatus(viewModel).then((res) => {
      if (res.responseObject?.errorCount) {
        let errorMessage = this.translate.instant("lblInvalidParameter");
        this.toaster.error(errorMessage);
        this.onCrossClickModel();
        this.spinner.hide();
      }
      else if (res.responseObject?.isSuccess) {
        if (!this.empty(res.responseObject.resultMessage)) {
          this.toaster.success(res.responseObject.resultMessage);
        }
        let successMessage = this.translate.instant("lblOnHoldStatusUpdated");
        this.toaster.success(successMessage);
        this.activeModal.close({
          success: true,
          isKeepOnHold: true
        });
        this.spinner.hide();
      }
      else {
        let errorMessage = this.translate.instant("lblOnHoldStatusUpdateFailed");
        this.toaster.error(errorMessage);
        this.onCrossClickModel();
        this.spinner.hide();
      }
    })
  }
  
  reasonCheckboxChange(reasonId: number,index:number,isSelected:boolean) {
    if(isSelected)
    {
      this.selectedReasonId = reasonId;
      this.onHoldStatusReasonList.forEach((x, _i) => {
        if (x.reasonId !== reasonId) {
          x.isSelected = false;
        }
      });
      this.onHoldStatusReasonList[index].isSelected = true;
    }
    else
    {
      this.selectedReasonId=null;
    }
  }

  private onHoldStatusReasonListDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = 1 + index;
        single.reasonId=element.reasonId;
        single.reason = element.reason;
        single.isDescriptionRequire = element.isDescriptionRequire;
        single.isSelected = false;
        single.description = null;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
}
